import React from "react";
import { IoMdClose } from "react-icons/io";

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="tgh fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="w-[70vw] max-h-[90vh] overflow-y-auto rounded-lg bg-white p-6 shadow-xl shadow-indigo-600 dark:bg-navy-700 dark:shadow-5xl md:w-[1/2] lg:w-1/3">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-bold"></h2>
          <button className="p-1 text-white bg-indigo-600" onClick={onClose}>
            <IoMdClose size={24} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;